// removed by extract-text-webpack-plugin
module.exports = {"Modal":"styles__Modal___1t_S7","ModalBody":"styles__ModalBody___1WATl","ModalClose":"styles__ModalClose___2VY0g","ModalTitle":"styles__ModalTitle___2Kn9C"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Form/TechnicalProblem/styles.scss
// module id = 1471
// module chunks = 0